// extracted by mini-css-extract-plugin
export var addressFields = "_nm-0";
export var animationContainer = "_nm-1";
export var footer = "_nm-2";
export var lineItems = "_nm-3";
export var modalContent = "_nm-4";
export var orderName = "_nm-5";
export var strong = "_nm-6";
export var warning = "_nm-7";